module.exports = __webpack_public_path__ + "img/banner.12229a87.png";